var map = {
	"./chinese-new-year-traditions/metadata.json": 6876,
	"./chinese-tea-culture/metadata.json": 3113,
	"./dragon-dance-traditions/metadata.json": 2991,
	"./lantern-festival-2025/metadata.json": 2907,
	"./mid-autumn-festival-2025/metadata.json": 330,
	"./year-of-snake-2025/metadata.json": 5572
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4717;